import { joinJSXElement } from "modules/Booking/FormPage/common/utils/joinJSXElement"
import styles from "modules/Booking/FormPage/components/FormAcceptation/components/ErrorsAcception/styles.module.scss"

interface ErrorsAcceptionProps {
    offerAccepted: boolean
    personalDataAccepted: boolean
    eulaAccepted: boolean
    informedAgreement: boolean
}

export function ErrorsAcception({
    offerAccepted,
    personalDataAccepted,
    eulaAccepted,
    informedAgreement,
}: ErrorsAcceptionProps) {
    const result: JSX.Element[] = []
    const offerAcceptedText = [
        <>примите оферту психолога</>,
        <>подтвердите, что вам есть 18&nbsp;лет</>,
    ]
    const personalDataAcceptedText = <>согласитесь с&nbsp;правилами обработки персональных данных</>
    const eulaAcceptedText = <>примите оферту сервиса</>
    const informedAgreementText = <>ознакомьтесь с&nbsp;информированным согласием</>
    const offerAndEulaErrorText = (
        <>Примите оферту психолога, оферту сервиса и&nbsp;подтвердите, что вам есть 18&nbsp;лет</>
    )

    if (!offerAccepted && !eulaAccepted && personalDataAccepted && informedAgreement) {
        result.push(offerAndEulaErrorText)
    } else {
        if (!offerAccepted) {
            result.push(offerAcceptedText[0], offerAcceptedText[1])
        }
        if (!personalDataAccepted) {
            result.push(personalDataAcceptedText)
        }
        if (!eulaAccepted) {
            result.push(eulaAcceptedText)
        }
        if (!informedAgreement) {
            result.push(informedAgreementText)
        }
    }

    return (
        <div className={styles.container} data-test-id="booking-form-acception-errors">
            {joinJSXElement(result)}
            {result.length > 0 && "."}
        </div>
    )
}
